
import styled from 'styled-components';
import React from 'react';
import FunctionsContext from './FunctionsContext';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Select from 'react-select';
import FormControl from '@material-ui/core/FormControl';


const Container = styled.div`
    width:400px;
    border-color:red;
    margin-top:7px;
`;

const useStyles = makeStyles((theme) => ({
    margin: {
      margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textField: {
        background:'white'
    },
}));

const customStyles = {
  control: (base, state) => ({
    ...base,
    borderColor: state.isFocused ? "rgb(61, 122, 150);" : null,
    boxShadow: 'none',
    border: state.isFocused  ? '1.5px solid lightgray' : '1px solid lightgray', // default border color
    "&:hover": {
      borderColor: state.isFocused ? "rgb(61, 122, 150);" : "black"
    }
  }),
  menu: base => ({
    ...base,
    borderRadius: 0,
    marginTop: 0
  }),
  menuList: base => ({
    ...base,
    padding: 0,
    maxHeight : window.innerHeight - 300
  })
};

const WorkflowStepsSelect = () => {
  const classes = useStyles();
  const context = React.useContext(FunctionsContext);

  const {functions} = context;
  
  let workflowStepsList = functions.selectedFunctionDetails.workflowSteps;

  const buildWorkflowStepData = workflowStep => {
    return { label: workflowStep.stepLabel, value : workflowStep.id }
  }

  let initialValue = {};
  workflowStepsList = workflowStepsList.map(buildWorkflowStepData);
  if (context.selectedWorkflowStep === '' && workflowStepsList.length > 0) {
    initialValue = { label: workflowStepsList[0].label, value : workflowStepsList[0].value };
    context.setSelectedWorkflowStep(initialValue.value);
  } 
  else {
    const wfStep = functions.selectedFunctionDetails.workflowSteps.find(ws => ws.id === context.selectedWorkflowStep);
    initialValue = { label: wfStep.stepLabel, value : wfStep.id };
  }

  

  return <Container>
    <Select
      value={initialValue}
      classes={classes}
      styles={customStyles}
      options={workflowStepsList}
      onChange={(selectedWorkflowStep) => {
        context.setSelectedWorkflowStep(selectedWorkflowStep.value);
      }}
      placeholder="Select role to edit"
    />
  </Container>
}

export default  WorkflowStepsSelect;